import React from "react";
import { CheckCircle } from "lucide-react"; // default icon

const ListWithIcon = ({
  items = [],
  icon: IconProp = CheckCircle,
  size = "md",
  layout = "vertical",
  cols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  iconColor = "text-green-600",
  iconBg = "",
  variant = "plain",
  className = "",
  itemcolor = "text-gray-700",
  iconClassName = "",
}) => {
  const normalized = items.map((it) =>
    typeof it === "string" ? { title: it } : it
  );

  const sizes = {
    sm: { gap: "gap-2", title: "text-sm", desc: "text-xs", icon: "h-4 w-4", pad: "p-1", radius: "rounded-md" },
    md: { gap: "gap-3", title: "text-base", desc: "text-sm", icon: "h-5 w-5", pad: "p-1.5", radius: "rounded-lg" },
    lg: { gap: "gap-4", title: "text-lg", desc: "text-base", icon: "h-6 w-6", pad: "p-2", radius: "rounded-xl" },
  };

  const vClasses = {
    plain: "",
    soft: `${iconBg || "bg-green-50"} ${sizes[size].radius}`,
    solid: `${iconBg || "bg-green-600"} ${sizes[size].radius} text-white`,
    outline: `ring-1 ring-white ${sizes[size].radius} text-white`,
  };

  const wrapperClasses =
    layout === "grid"
      ? `grid ${cols} ${className}`
      : `flex flex-col ${className}`;

  return (
    <ul role="list" className={wrapperClasses}>
      {normalized.map((it, idx) => (
        <li key={idx} className={`flex ${sizes[size].gap} p-2 items-start`}>
          {/* Icon */}
          <span
            className={`inline-flex items-center justify-center ${sizes[size].pad} ${vClasses[variant]} ${iconClassName} ${variant === "solid" ? "" : iconColor}`}
            aria-hidden="true"
          >
            {React.isValidElement(IconProp) ? (
              React.cloneElement(IconProp, { className: sizes[size].icon })
            ) : IconProp ? (
              <IconProp className={sizes[size].icon} />
            ) : (
              <span className={sizes[size].icon}>•</span>
            )}
          </span>

          {/* Text */}
          <div className="mb-3">
            <div className={`${sizes[size].title} ${itemcolor} leading-relaxed border border-dashed border-b-green-500 border-transparent`}>
              {it.title}
            </div>
            {it.desc && (
              <p className={`${sizes[size].desc} ${itemcolor}`}>–  {it.desc}</p>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ListWithIcon;
